<template>
  <div class="pincode">
    <input
      v-for="(letter, index) in letters"
      :key="letter.key"
      :ref="`${baseRefName}${index}`"
      v-model="letter.value"
      v-bind="$attrs"
      type="tel"
      placeholder="•"
      class="pincode__input"
      size="1"
      @focus="setFocusedLetterIndex(index)"
      @keydown.delete="onDelete(index, $event)"
    >
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      },
      length: {
        type: Number,
        default: 4
      },
    },
    data: () => ({
      baseRefName: 'pincode',
      letters: [],
      focusedLetterIdx: -1,
      watchers: {},
    }),
    computed: {
      pinCodeComputed() {
        return this.letters.reduce((pin, letter) => pin + letter.value, '');
      },
    },
    watch: {
      value(val) {
        this.acceptParentValue();
      },
      length: {
        handler(val) {
          this.unsetLettersWatchers();
          this.letters = [];
          for (let i = 0; i < val; i += 1) {
            this.letters.push({key: i, value: ''});
            this.watchers[`letters.${i}.value`] = this.$watch(`letters.${i}.value`, (newVal, oldVal) => {
              this.onLetterChanged(i, newVal, oldVal);
            });
          }
        },
        immediate: true,
      },
      focusedLetterIdx(val) {
        this.focusLetterByIndex(val);
      },
      pinCodeComputed(val) {
        this.$emit('input', val);
      },
    },
    mounted() {
      this.acceptParentValue();
      this.focusLetterByIndex(0);
    },
    methods: {
      acceptParentValue() {
        if (!this.value) return;
        if (this.value.length !== this.length) {
          return;
        }
        const letters = this.value.split('');
        for (let i = 0; i < letters.length; i += 1) {
          this.letters[i].value = letters[i] || '';
        }
      },
      letterIsValid(letter) {
        let letterIsValid = true;
        if (letter.length === 1 && !letter.match('^[0-9]*$')) {

          letterIsValid = false;
        } else if (letter.length > 1) {
          letterIsValid = false;
        }
        return letterIsValid;
      },
      onLetterChanged(index, newVal, oldVal) {
        if (!this.letterIsValid(newVal)) {
          this.$nextTick(() => {
            this.letters[index].value = oldVal;
          });
        } else if (newVal.length) {
          this.setFocusedLetterIndex(this.focusedLetterIdx + 1);
        }
      },
      setFocusedLetterIndex(newIndex) {
        if (newIndex < 0 || newIndex >= this.length) {
          return;
        }
        this.focusedLetterIdx = newIndex;
      },
      focusLetterByIndex(index) {
        const refName = `${this.baseRefName}${index}`;
        this.$refs[refName][0].focus();
        this.$refs[refName][0].select();
      },
      onDelete(index, e) {
        if (!this.letters[index].value) {
          this.setFocusedLetterIndex(this.focusedLetterIdx - 1);
          e.preventDefault();
        }
      },
      unsetLettersWatchers() {
        Object.keys(this.watchers).forEach((watcher) => {
          this.watchers[watcher]();
        });
      },
    },
  }
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .pincode {
    display: flex;
    margin-bottom: 1rem;
    &__input {
      border-radius: 0;
      text-align: center;
      font-size: 2rem;
      padding-top: 5px;
      padding-bottom: 5px;
      background-color: $white;
      border: 1px solid $pigeon;
      color: $tangaroa;
      outline: none;
      flex: 1;
      width: 100%;
      margin: 0;
      box-shadow: none;
      transition: box-shadow 0.3s, border 0.3s;
      &:focus {
        box-shadow: 0 0 0 3px rgba($pigeon, 0.5);
      }
      &:not(:last-child) {
        border-right: 0;
      }
      &:first-child {
        border-top-left-radius: $form-border-radius;
        border-bottom-left-radius: $form-border-radius;
      }
      &:last-child {
        border-top-right-radius: $form-border-radius;
        border-bottom-right-radius: $form-border-radius;
      }
    }
  }
</style>
